import DeliveryIcon from './DeliveryIcon';

export default DeliveryIcon;
